import HasRole from "modules/5_view_helpers/HasRole";
import { canUseProformaClaims } from "modules/administration/proforma_claims/access";
import { createCustomFormLinks, createMenuItems } from "../helpers";

const getAdministrationNav = (administration_custom_forms, administration_menus) => {
  const AutomatedInvoiceRoles = HasRole({ resource_type: "Administration::AutomatedInvoice" });
  const ProformaClaimRoles = canUseProformaClaims();
  if (AutomatedInvoiceRoles || ProformaClaimRoles || _.isNotEmpty(administration_custom_forms) || _.isNotEmpty(administration_menus)) {
    let adminMenu = { icon: "fa fa-book", label: "Administration", content: [] };
    if (AutomatedInvoiceRoles) {
      adminMenu?.content?.push({ label: "Automated Invoices", to: "/administration/automated_invoices" });
    }
    if (ProformaClaimRoles) {
      adminMenu?.content?.push({ label: "Proforma Claims", to: "/administration/proforma_claims" });
    }
    adminMenu.content = _.concat(
      adminMenu?.content,
      createCustomFormLinks(administration_custom_forms),
      createMenuItems(administration_menus)
    );
    return adminMenu;
  }
};

export default getAdministrationNav;
